import request from '@/utils/request'
const api = {
  Get(data) {
    return request({
      url: 'admin/configure/get',
      method: 'post',
      data
    })
  },
  Save(data) {
    return request({
      url: 'admin/configure/createOrUpdate',
      method: 'post',
      data
    })
  }
}
export default api
